export let Environment;

(function (Environment) {
  Environment["Local"] = "local";
  Environment["PullRequest"] = "pull-request";
  Environment["Development"] = "development";
  Environment["Staging"] = "staging";
  Environment["Production"] = "production";
})(Environment || (Environment = {}));

const ENV_ENVIRONMENT = process.env.REACT_APP_ENVIRONMENT || Environment.Production;

if (!ENV_ENVIRONMENT || !Object.values(Environment).includes(ENV_ENVIRONMENT)) {
  const message = `Invalid app environment: ${ENV_ENVIRONMENT || '-'}`;

  if (process.env.NODE_ENV === 'production') {
    throw new Error(message);
  } else if (process.env.NODE_ENV === 'development') {
    console.warn(message);
    console.warn('Fallback to production environment.');
  }
}

const ENVIRONMENT = ENV_ENVIRONMENT || Environment.Production;

if (process.env.NODE_ENV === 'development') {
  console.log(`Current environemnt: ${ENVIRONMENT}`);
}

export const isDebug = ![Environment.Production, Environment.Staging].includes(ENVIRONMENT);
export default ENVIRONMENT;